export default function ErrorView() {
	return (
		<div>error view</div>
	);
}
